import { render } from "./systemTab.vue?vue&type=template&id=c9702814&scoped=true"
import script from "./systemTab.vue?vue&type=script&lang=js"
export * from "./systemTab.vue?vue&type=script&lang=js"

import "./systemTab.vue?vue&type=style&index=0&id=c9702814&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\zh-frontend\\microfront-main\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9702814"]])

export default __exports__